import AppInstallIcon from "@/User/Assets/Svgs/AppInstall.svg";
import Merit01SVG from '@/User/Assets/Svgs/Merit01.svg';
import Merit02SVG from '@/User/Assets/Svgs/Merit02.svg';
import PcAppBannerSVG from "@/User/Assets/Svgs/PcAppBanner.svg";
import FootLogo from '@/User/Assets/Svgs/PrimaryFoot.svg';
import EntryButton from "@/User/Components/Buttons/EntryButton";
import InfoButton from "@/User/Components/Buttons/InfoButton";
import { ANDROID_APP_URL, IOS_APP_URL } from "@/Utils/MobileAppUtils";
import { detectDevice } from "@/utils";
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const AppAppeal = () => {
    const { isIOS } = detectDevice();

    return (
        <section id="bottom-content" className="bg-alice-blue-3 pt-12 pb-5">
            <div className="container">
                <div className="flex flex-col gap-6 w-full md:w-375px lg:w-680px md:mx-auto px-1 md:px-6 lg:px-0 mb-2.5 md:mb-6.5">
                    <div className="flex flex-col items-center justify-center gap-2">
                        <LazyLoadImage src={FootLogo} alt="よりスムーズな独立を目指すには" className="size-6" />
                        <h2 className="flex flex-col text-primary justify-center items-center">
                            <span className="leading-tight">よりスムーズな独立を</span>
                            <span className="leading-tight">目指すには</span>
                        </h2>
                    </div>
                    <p className="text-midnight text-lg font-light text-center">
                        <span className="text-primary underline underline-offset-2">リラパスアプリ</span>を活用することで企業と<br />のコミュニケーションがよりスムーズに
                    </p>
                    <div className="flex flex-col lg:flex-row gap-6">
                        <div className="text-center flex flex-col gap-4 lg:w-1/2">
                            <h3 className="text-primary leading-none">Merit 01</h3>

                            <LazyLoadImage
                                src={Merit01SVG}
                                alt="Merit 01"
                                className="m-auto w-80 h-28"
                            />

                            <p className="text-center flex flex-col md:block md:text-left">
                                <span>スカウト・応募後はメッセージ機能でやりとり！</span>
                                <span>スムーズに説明会や面談の調整ができる</span>
                            </p>
                        </div>
                        <div className="text-center flex flex-col gap-4 lg:w-1/2">
                            <h3 className="text-primary leading-none">Merit 02</h3>

                            <LazyLoadImage
                                src={Merit02SVG}
                                alt="Merit 02"
                                className="m-auto w-80 h-28"
                            />

                            <p className="text-center flex flex-col md:text-left">
                                <span className="md:hidden">企業からメッセージが届くと</span>
                                <span>プッシュ通知も来るため見逃しがない！</span>
                                <span>スピーディーな活動が可能に</span>
                            </p>
                        </div >
                    </div >
                    <div className="flex flex-col items-center justify-center gap-4">
                        <div className="w-640px h-188px hidden lg:block">
                            <LazyLoadImage
                                src={PcAppBannerSVG}
                                alt="よりスムーズな独立を目指すには"
                            />
                        </div>

                        <InfoButton className="w-full py-4 flex items-center justify-center gap-2 lg:hidden"
                            textClass="font-base text-white"
                            isRounded={true} roundedClass="rounded-lg"
                            isShadow={true}
                            as={'link'}
                            href={isIOS ? IOS_APP_URL : ANDROID_APP_URL}
                        >
                            アプリをインストールする
                            <LazyLoadImage src={AppInstallIcon} alt="アプリを取得する" className="size-6" />
                        </InfoButton>

                        <div className="w-full lg:max-w-337px">
                            <EntryButton labelText="まずはウェブで会員登録する" className="lg:px-4 py-4" classIconName="size-6" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppAppeal;
